<template>
<div id="app">
    <div v-if="$route.fullPath !== '/'">
      <top-bar ></top-bar>
      <side-bar></side-bar>
      <div id="sub-container" >
        <router-view/>
      </div>
    </div>
    <div style="height:100%; background-color: #F0F3F4;" v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
import SideBar from './components/SideBar'
import TopBar from './components/TopBar'
export default {
  name: 'App',
  components: {
    SideBar,
    TopBar
  }
}
</script>

<style>
@import './assets/bootstrap-helper.min.css';
.row {
  margin-right: 0px;
  margin-left: 0px;
}
#sub-container {
  position: relative;
  top: 5rem;
  left: 15rem;
  width: calc(100% - 15rem);
}
::-webkit-scrollbar {
 height: 0.4rem;
 width: 0.4rem;
 }
 ::-webkit-scrollbar-track {
 -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
 }
 ::-webkit-scrollbar-thumb {
 background-color: darkgrey;
 outline: 1px solid slategrey;
 }
.text-center {
  text-align: center
}
.value {
  font-size: 26px;
  color: #6ddabe;;
}
.items-header {
  font-size: 14px
}
.content-heading {
  padding: 10px 0;
  font-weight: 300;
  color: #67757c;
}
.items {
  padding: 5px;
}
.center-align{
  width: 80%;
  margin: auto;
}
.flex-end {
  justify-content: flex-end;
}
.flex-start {
  justify-content: flex-start;
}
.flex-space-between {
  justify-content: space-between
}
.v-align-center {
  align-self: center
}
.cr {
  align-self: flex-end;
  text-align: right;
}
.program-name {
  color: #00496b;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  line-height: 20px;
  font-size: 20px;
}
#container {
    position: relative;
    overflow: hidden;
    /*left: 100px;*/
    top: 80px;
    /*width: calc(100% - 200px);*/
    min-height: calc(100vh - 80px);
    background: #f5f5f5;
    background-size: cover;
  }
  .el-table td {
    font-family: "Poppins", sans-serif;
    color: #67757c;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(10px);
  }
  #container.login {
    top: 0px;
    width: 100%;
    left: 0px;
    height: 100vh;
    margin: 0px;
    padding: 0px;
  }
  #container.home {
    top: 0px;
    width: 100%;
    left: 0px;
    height: 100vh;
    margin: 0px;
    padding: 0px;
  }
  .login #loginBg {
    margin-left: 0px !important;
  }
  .home #homeBg {
    margin-left: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue